export const tutorialSeriesMap: Record<
  string,
  { flow: Record<string, string | null>; steps: Record<string, any[]> }
> = {
  tour_1: {
    flow: {
      "/home": "/project/254",
      "/project/254": "/project/255",
      "/project/255": "/project/258",
      "/project/258": null,
    },
    steps: {
      "/home": [
        {
          target: ".project-card-254",
          content:
            "이 프로젝트는 튜토리얼용으로, \n다음 버튼을 클릭하면 튜토리얼이 시작해. \nspacebar 혹은 esc로도 조작이 가능해! ",
          disableBeacon: true,
          // spotlightClicks: true,
          // disableOverlayClose: true,
        },
      ],
      "/project/254": [
        {
          target: ".step2",
          content:
            "이 테이블은 분류대상의 이미지야. \n우측의 이미지를 보면서 불량을 걸러내는게 핵심이지!",
          disableBeacon: true,
        },
        {
          target: ".step3",
          content:
            "해당 이미지를 보고 불량 여부를 판단하면 돼. \n\n이제 분류를 어느정도 진행 한 프로젝트를 살펴보면서 기능을 알아보러 가볼까?",
          disableBeacon: true,
        },
      ],
      "/project/255": [
        {
          target: ".steps_2_5",
          content: "프로젝트의 모든 기능을 담은 버튼이야",
          disableBeacon: true,
        },
        // {
        //   target: ".steps_2_6",
        //   content: "AI 서버의 상태를 확인할 수 있어",
        //   disableBeacon: true,
        // },
        // {
        //   target: ".steps_2_1",
        //   content:
        //     "이 버튼을 클릭하거나 키보드 단축키를 이용해 라벨링을 할 수 있어",
        //   disableBeacon: true,
        // },
        // {
        //   target: ".steps_2_2",
        //   content: "이미지 필터링 기능 On/Off 와 필터 목록을 확인 할 수 있어",
        //   disableBeacon: true,
        // },
        // {
        //   target: ".steps_2_3",
        //   content: "이 버튼은 이미지별 라벨 기록을 확인 할 수 있어",
        //   disableBeacon: true,
        // },
        // {
        //   target: ".steps_2_4",
        //   content: "이 버튼을 누르면 키보드 단축키 설정을 할 수 있어",
        //   disableBeacon: true,
        // },
        // {
        //   target: ".steps_2_7",
        //   content: "NG 라벨링이 10개 이상이 되면 \n학습을 시작할 수 있어!",
        //   disableBeacon: true,
        // },
        // {
        //   target: ".steps_2_8",
        //   content: "다음 버튼을 눌러 분류 완성본의 프로젝트를 살펴보자!",
        //   disableBeacon: true,
        // },
      ],
      "/project/258": [
        {
          target: ".steps_3_6",
          content:
            "AI 학습과 검사가 끝난 프로젝트의 데이터야! \n간략하게 설명해줄게.",
          disableBeacon: true,
        },
        // {
        //   target: ".steps_3_4",
        //   content: "AI가 학습 후 검사한 분류 결과야!",
        //   disableBeacon: true,
        // },

        // {
        //   target: ".steps_3_5",
        //   content: "정확도를 점수로 확인가능해!",
        //   disableBeacon: true,
        // },

        // {
        //   target: ".steps_3_7",
        //   content: "AI의 학습, 검사가 정상적으로 이루어졌는지 확인할 수 있어",
        //   disableBeacon: true,
        // },
        {
          target: ".steps_2_8",
          content: "이제 직접 프로젝트를 사용해볼까?",
          disableBeacon: true,
        },
      ],
    },
  },
  tutorial_1: {
    flow: {
      // "/home": "/test",
      // "/test": null,
      "/home": null,
    },
    steps: {
      "/home": [
        {
          target: ".project-card-254",
          content: "프로젝트 우클릭 후 복제를 눌러봐!",
          disableBeacon: true,
          spotlightClicks: true,
          disableOverlayClose: true,
        },
      ],
      "/test": [
        {
          // target: ".step1",
          // content: "이것은 테스트용 튜토리얼이야.",
          // disableBeacon: true,
        },
      ],
    },
  },
};
